const jwt = currentUser => {
    fetch("https://review-server-rdm-jony.vercel.app/jwt", {
        method: "POST",
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify(currentUser)
    })
        .then(res => res.json())
        .then(data => {
            console.log(data)
            localStorage.setItem("review-token", data?.token)
        })
        .catch(er => console.log(er))
}
export default jwt;